angular.module( 'mtic' ).service( 'TeacherClassStatsService', function ( $log , $q ) {
  /**
   * initializes all stats
   * @param  {ModuleResource} moduleResource
   * @param  {Objcet} statDef
   * @param  {String} statName
   * @return {Null}
   */
  var initializeStats = function ( moduleResource, statDef, statName ) {
    if ( !moduleResource.stats ) {
      moduleResource.stats = {};
    }
    var stats = moduleResource.stats;
    var meta_locks = moduleResource.config.meta_locks;
    if (!stats[statName]) {
      stats[statName] = {
        total: 0,
        attempts: 0,
        completed: 0,
        timespent: 0,
        score_max_mean: 0,
        locked: true
      }
      if(meta_locks && meta_locks[statName]) {
        stats[statName].locked = meta_locks[statName].length > 0;
      }
      var stat = stats[statName];
      switch ( statDef.by ) {
        case 'resource_type':
          stat.total = _.filter( moduleResource.children, function ( childResource ) {
            return childResource.resource_type === statDef.value;
          }).length
          break;
        case 'slug':
          stat.total = _.filter( moduleResource.children, function ( childResource ) {
            return childResource.slug === statDef.value;
          }).length
          break;
        case 'cluster_or_slug':
          stat.total = _.filter( moduleResource.children, function ( childResource ) {
            return statDef.value.cluster.indexOf(childResource.slug) > -1
          }).length
          break;
        default:
          throw new Error( 'Not Supported Stat Type ' + statDef.by )
      }
    }
  }
  /**
   * Init to all stats for moduleResource
   * @param  {ModuleResource} moduleResource
   * @return {}
   */
  var initStatsForModule = function ( moduleResource ) {
    if ( ! moduleResource.stats ) {

      _.map( moduleResource.config.stats, function ( statDef, statName ) {
        initializeStats( moduleResource, statDef, statName )
      })
    }
    return;
    // if ( moduleResource.config.stats ) {
    //   if ( ! moduleResource.stats ) {
    //     _.map( moduleResource.config.stats, function ( statDef, statName ) {
    //       initializeStats( moduleResource, statDef, statName )
    //     })
    //   }
    //   return;
    // } else {
    //   throw new Error( 'No Stats defined for ' + moduleResource.name );
    // }
  }
  /**
   * Updates the state of the stats
   * @param  {Object} stat
   * @param  {StudentResourceState} studentResourceState
   * @return {}
   */
  var workbatch_list = [];
  var updateStatState = function(stat, studentResourceState, workbatch_id, resource) {
    if(workbatch_list.indexOf(workbatch_id) > -1 || !studentResourceState){
      return;
    }
    workbatch_list.push(workbatch_id);
    stat.attempts++
    stat.timespent += studentResourceState.time_spent_total
    if(studentResourceState.complete) {
      stat.completed ++;
      stat.locked = false;
    }
    var use_score = resource.display && resource.display.color === 'blue' && studentResourceState.complete ? 1 : studentResourceState.score_max;
    stat.score_max_mean += (use_score / stat.total);
  }
  /**
   * Computes stats
   * @param  {Array<StudentResourceState>} work
   * @param  {ModuleResourceWithStats} workSummary
   * @return {Promise}
   */
  var statCompute = function ( work, workSummary ) {
    workbatch_list = [];
    return $q.all(work.map(function(classWork){
      return $q(function(resolve, reject){
        var resource = classWork.WorkBatch.Resource;
        var studentResourceState = classWork.WorkBatch.StudentResourceState;
        var parentModuleResource = workSummary[resource.parent_resource_id];
        if(parentModuleResource){
          var cur_resource =  _.find(parentModuleResource.children, {id: resource.id});
          _.map( parentModuleResource.config.stats, function ( statDef, statName ) {
            var stat;
            switch (statDef.by) {
              case 'slug':
                if(resource.slug === statDef.value){
                  stat = parentModuleResource.stats[statName]
                  updateStatState(stat, studentResourceState, classWork.WorkBatch.id, cur_resource)
                }
                break;
              case 'resource_type':
                if(resource.resource_type === statDef.value){
                  stat = parentModuleResource.stats[statName]
                  updateStatState(stat, studentResourceState, classWork.WorkBatch.id, cur_resource)
                }
                break;
              case 'cluster_or_slug':
                //the cluster_or_slug setting is used to grade using an array of assessments(cluster) which can also be overwritten by one final assessment(slug)
                //this is currently used for formatives with final summative format. The value should be {"cluster":[array of slugs], "slug"://final slug}
                //additionally the second part(slug) is optional and can be used purely for the cluster
                stat = parentModuleResource.stats[statName]
                if(resource.slug === statDef.value.slug && studentResourceState.complete){           
                  stat.timespent = studentResourceState.time_spent_total
                  stat.locked = false;
                  stat.score_max_mean = studentResourceState.score_max;
                  stat.dont_change_by_cluster = true;
                }else if(!stat.dont_change_by_cluster && statDef.value.cluster.indexOf(resource.slug) > -1){       
                  updateStatState(stat, studentResourceState, classWork.WorkBatch.id, cur_resource);
                }
                break;
              default:
                $log.warn("Could not match a stat type for", statDef)
            }
          })
        }else{
          // $log.warn( '[[TeacherDataService]] PARENT RESOURCE IS NOT LOADED FOR', resource )
        }
        resolve();
      })
    }))
  }
  var computeMetaLock = function(stats, statName, metaLocksDef, locksComputed) {
    if(!locksComputed[statName]){
      var unlockedBys = metaLocksDef[statName];
      if(stats[statName].locked && unlockedBys.length > 0) {
        var unlockedBysCompleted = unlockedBys.filter(function(lockName){
          computeMetaLock(stats, lockName, metaLocksDef, locksComputed)
          return stats[lockName].completed > 0
        })
        stats[statName].locked = unlockedBysCompleted.length !== unlockedBys.length
      }else if(unlockedBys.length > 0){
        stats[statName].locked = false;
      }
      locksComputed[statName] = true;
    }
  }
  var computeMetaLocks = function(stats, metaLocksDefs) {
    var locksComputed = {};
    if(metaLocksDefs){
      _.map(metaLocksDefs, function(unlockedBys, statName){
        computeMetaLock(stats, statName, metaLocksDefs, locksComputed)
      })
    }
  }
  return {
    computeStats: function ( moduleData, userRoles , studentMap) {
      return $q.all(userRoles.map( function ( userRole ) {
        return $q(function(resolve, reject){
          var work = userRole.User.ClassWorks;
          var moduleWorkSummary = angular.copy(moduleData);
          _.map(moduleWorkSummary, initStatsForModule);
          if ( work.length > 0 ) {
            statCompute(work, moduleWorkSummary).then(function(){
              _.map(moduleWorkSummary, function(module){
                computeMetaLocks(module.stats, module.config.meta_locks)
              })
              resolve({
                user: studentMap[userRole.user_id],
                moduleWorkSummary: moduleWorkSummary
              })
            })
          }else{
            _.map(moduleWorkSummary, function(module){
              computeMetaLocks(module.stats, module.config.meta_locks)
            })
            resolve({
              user: studentMap[userRole.user_id],
              moduleWorkSummary: moduleWorkSummary
            })
          }
        })
      }))
    }
  }
})
